var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 100,
    viewBox: "0 0 93 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.813538 56.3173V76.8407H14.302V56.3173H0.813538ZM0.813538 37.3135V47.3032C0.813538 49.5919 2.68953 51.4679 4.97825 51.4679C7.26697 51.4679 9.14296 49.5919 9.14296 47.3032V38.8518L20.5021 27.4926C22.1155 25.8793 22.1155 23.2247 20.5021 21.6114C18.8888 19.998 16.2342 19.998 14.6209 21.6114L2.18302 34.0399C1.7703 34.4526 1.46076 34.9403 1.2544 35.4562C0.972997 36.019 0.813538 36.6475 0.813538 37.3135Z",
    fill: "#FF9571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6292 0H18.1946C16.5344 0 15.1837 1.35072 15.1837 3.01097V72.8637C15.1837 74.524 16.5344 75.8747 18.1946 75.8747H65.6292C67.2895 75.8747 68.6402 74.524 68.6402 72.8637V3.01097C68.6402 1.35072 67.2895 0 65.6292 0Z",
    fill: "#FFFFF1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.0912 13.1038C38.4179 13.1038 35.9885 14.1918 34.2344 15.9459C32.4804 17.6906 31.3923 20.12 31.3923 22.7933C31.3923 25.4666 32.4804 27.896 34.2344 29.6501C35.9885 31.4041 38.4085 32.4922 41.0912 32.4922C43.7645 32.4922 46.1939 31.4041 47.948 29.6501C49.702 27.896 50.7901 25.476 50.7901 22.7933C50.7901 20.12 49.702 17.6906 47.948 15.9365C46.1939 14.1825 43.7645 13.1038 41.0912 13.1038ZM31.8238 13.5259C34.1969 11.1527 37.4705 9.68945 41.0912 9.68945C44.7119 9.68945 47.9855 11.1527 50.3586 13.5259C52.7317 15.899 54.195 19.1726 54.195 22.7933C54.195 26.414 52.7317 29.6876 50.3586 32.0607C47.9855 34.4338 44.7119 35.8971 41.0912 35.8971C37.4705 35.8971 34.1969 34.4338 31.8238 32.0607C29.4506 29.6876 27.9873 26.414 27.9873 22.7933C27.978 19.1726 29.4506 15.899 31.8238 13.5259Z",
    fill: "#FFF3D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.6039 21.6301C35.0505 21.0767 35.0505 20.1856 35.6039 19.6415C36.1573 19.0881 37.0484 19.0881 37.5925 19.6415L42.4794 24.5285L54.1857 12.8223C54.7391 12.2689 55.6302 12.2689 56.1742 12.8223C56.7276 13.3757 56.7276 14.2668 56.1742 14.8108L43.4737 27.5113C42.9203 28.0648 42.0292 28.0648 41.4852 27.5113L35.6039 21.6301Z",
    fill: "#7C0032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.813538 43.9546V54.0287C0.813538 59.5723 5.34407 64.1028 10.8876 64.1028H13.1295C18.673 64.1028 23.2036 59.5723 23.2036 54.0287V43.9546H15.1743C15.1743 45.6242 13.8236 46.9749 12.1539 46.9749C10.4843 46.9749 9.13358 45.6242 9.13358 43.9546H0.813538Z",
    fill: "#FF9571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1837 33.6553V47.472C15.1837 49.6763 16.9846 51.4866 19.1983 51.4866C21.4026 51.4866 23.2129 49.6856 23.2129 47.472V33.6553C23.2129 31.451 21.4026 29.6406 19.1983 29.6406C16.9846 29.6406 15.1837 31.451 15.1837 33.6553Z",
    fill: "#FF9571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.813538 64.103V90.3295C0.813538 95.6479 5.16585 100 10.4843 100C15.8028 100 20.1551 95.6479 20.1551 90.3295V64.103H0.813538Z",
    fill: "#7C0032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2657 37.107V39.9397V42.8006V65.5377H67.8242V52.7716C62.8434 52.19 58.9507 47.9221 58.9507 42.8006V36.2722V32.7547V22.493C58.9507 20.2981 60.7516 18.4971 62.9466 18.4971C65.1415 18.4971 66.9424 20.2981 66.9424 22.493V32.7547H66.9518C67.0925 34.8464 68.8278 36.4973 70.9571 36.4973C73.0863 36.4973 74.8216 34.8464 74.9623 32.7547H74.9717V26.4982L64.0159 15.533C62.7965 14.3136 62.7965 12.3063 64.0159 11.0869C65.2353 9.86751 67.2426 9.86751 68.462 11.0869L79.9994 22.6243C80.5622 23.0464 80.9843 23.6561 81.1625 24.3596C81.275 24.7442 81.3032 25.1475 81.2657 25.5508V37.107Z",
    fill: "#FF9571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5107 45.7929L91.2554 44.0482L93.0001 42.3035L62.7121 12.0062L57.675 10.4585L59.2227 15.5049L89.5107 45.7929Z",
    fill: "#FFD300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2656 52.8374V90.3573C81.2656 95.657 76.9321 99.9906 71.6324 99.9906C66.3327 99.9906 61.9991 95.657 61.9991 90.3573V52.8374H81.2656Z",
    fill: "#7C0032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M41.0912 44.6394C38.4179 44.6394 35.9885 45.7275 34.2344 47.4815C32.4804 49.2356 31.3923 51.6556 31.3923 54.3383C31.3923 57.0116 32.4804 59.441 34.2344 61.1951C35.9885 62.9491 38.4085 64.0372 41.0912 64.0372C43.7645 64.0372 46.1939 62.9491 47.948 61.1951C49.702 59.441 50.7901 57.021 50.7901 54.3383C50.7901 51.665 49.702 49.2356 47.948 47.4815C46.1939 45.7181 43.7645 44.6394 41.0912 44.6394ZM31.8238 45.0615C34.1969 42.6884 37.4705 41.2251 41.0912 41.2251C44.7119 41.2251 47.9855 42.6884 50.3586 45.0615C52.7317 47.4346 54.195 50.7083 54.195 54.3289C54.195 57.9496 52.7317 61.2232 50.3586 63.5964C47.9855 65.9695 44.7119 67.4422 41.0912 67.4422C37.4705 67.4422 34.1969 65.9789 31.8238 63.6057C29.4506 61.2326 27.9873 57.959 27.9873 54.3383C27.978 50.7083 29.4506 47.4346 31.8238 45.0615Z",
    fill: "#FFF3D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8887 19.9421L60.2076 19.6044C60.9299 18.9197 61.896 18.4976 62.9559 18.4976C65.1508 18.4976 66.9518 20.2985 66.9518 22.4934V25.3074L65.2071 27.2397L59.8887 19.9421Z",
    fill: "#FF9571"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventImg2);
export default __webpack_public_path__ + "static/media/event-img2.61c7031d7103f5a68ec8fcdff9c8d0a5.svg";
export { ForwardRef as ReactComponent };